module.exports = __webpack_public_path__ + "ratings.f400def7002476e73ef7a547a2fc905b.png";